module.exports = __webpack_public_path__ + "static/media/our-story.605b5aa7.webp";